'use strict';
module.exports = function IntervalProgress(callback, duration, intervalController) {
	let isFinished, startTs;
	const self = this,
		complete = () => {
			if (!isFinished) {
				callback(1);
				isFinished = true;
			}
		},
		step = (timestamp) => {
			if (!startTs) {
				startTs = timestamp;
			}
			if (isFinished) {
				return;
			}
			const progress = timestamp - startTs,
				ratio = Math.min(1, progress / duration);
			callback(ratio);
			if (progress > duration) {
				complete();
			} else {
				intervalController.requestAnimationFrame(step);
			}
		};
	self.finish = complete;
	intervalController.requestAnimationFrame(step);
};
